import React, {Component} from 'react';
import Card from './card';

class Form extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const {handleChange, handleSubmit, disable, sampleRequirement, requirement} = this.props;
        return (<div className="requirement-container">
                <div className="form-container">
                    <div className="form-container-title"><b>Hey, please post your requirement here.</b></div>
                    <textarea value={requirement} className="requirement-value" placeholder="Enter your Requirement here..." cols='80'
                              rows='15' onChange={ev => handleChange(ev)}></textarea>
                    <button disabled={disable} className={disable ? 'btn-disable btn' : 'btn'} onClick={() => handleSubmit()}>Submit
                    </button>
                </div>
                <div className="card-container">
                    <div className="card-container-title">
                        <b>Sample Requirements</b>
                    </div>
                    <div className="card-scroll-container">
                        {
                            sampleRequirement.length > 0 && true ? sampleRequirement.map((item, index) =>
                                <Card handleChange={handleChange} sampleRequirement={item}/>
                            ): null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Form;